import type { HeaderContent } from './headerContent';

/** Shape every storefront header uses for its own nav links. */
export interface HeaderNavLink {
  key: string;
  label: string;
  href: string;
  accent?: boolean;
}

/**
 * The menu the merchant configured in the builder, or an empty array.
 *
 * Headers resolve `headerContent` for their theme, and several then ignored
 * `navItems` entirely and rendered a hardcoded list instead — so a merchant
 * could edit their menu in the builder, save, and see no change on the
 * storefront. Worse, some of those hardcoded lists pointed several
 * differently-labelled links at the same page.
 *
 * Callers use this first and fall back to their own template-appropriate
 * default, which keeps each template's character (Atelier's "The Collection",
 * Monolith's in-page anchors) while letting a merchant override it.
 */
export function configuredHeaderNav(
  headerContent: HeaderContent | null | undefined,
): HeaderNavLink[] {
  const items = headerContent?.navItems;
  if (!Array.isArray(items)) return [];
  return items
    .filter((item) => item && typeof item.label === 'string' && item.label.trim() && typeof item.url === 'string' && item.url.trim())
    .map((item, i) => ({
      key: `cfg-${i}-${item.label}`,
      label: item.label,
      href: item.url,
    }));
}
